export type CaseCopilotFieldRefContext = {
  label: string;
  formKind: "task" | "action";
  formKey: string;
  fieldKey: string;
};

const escapeXmlAttr = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export const buildCaseCopilotRefMessage = (
  ref: CaseCopilotFieldRefContext,
  body: string,
): string => {
  const attrs = [
    `label="${escapeXmlAttr(ref.label)}"`,
    `form_kind="${escapeXmlAttr(ref.formKind)}"`,
    `form_key="${escapeXmlAttr(ref.formKey)}"`,
    `field_key="${escapeXmlAttr(ref.fieldKey)}"`,
  ].join(" ");
  return `<ref ${attrs}/>\n${body}`;
};
